// Library import
import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';
import Proptypes from 'prop-types';

// Components Import
import { MultiPostForm, SinglePostForm } from '@/components';

const EditPost = ({ postData, locationsCsv }) => {
  const url = new URL(window.location.href);
  const [typeParam, setTypeParam] = useState(null);

  useEffect(() => {
    setTypeParam(`${url.searchParams.get('type')}`);
  }, []);

  const renderSection = () => {
    switch (typeParam) {
      case 'case_study':
        return <MultiPostForm postData={postData} />;

      case 'skill_support':
        return <SinglePostForm postData={postData} locationsCsv={locationsCsv} />;

      case 'job_hunting':
        return <SinglePostForm postData={postData} locationsCsv={locationsCsv} />;

      case 'news':
        return <SinglePostForm postData={postData} locationsCsv={locationsCsv} />;
    }
  };

  return <>{renderSection()}</>;
};

export default EditPost;

EditPost.prototype = {
  postData: Proptypes.object
};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
  if (!element) {
    element = document.getElementById('EditPost');

    const data = element?.dataset?.post && JSON.parse(element.dataset.post);
    const root = element && createRoot(element);
    const locationsCsv = element?.dataset?.locations && JSON.parse(element.dataset.locations);
    if (element) root.render(<EditPost postData={data} locationsCsv={locationsCsv} />);
  }
});
